import {
  createClient,
  authEndpoints,
  approvalEndpoints,
  hospitalEndpoints,
  pushEndpoints,
  settingsEndpoints,
  intakeEndpoints,
} from '@refdash/api-client';

let didForceLogout = false;

const client = createClient({
  baseUrl: '',
  app: 'rep',
  onUnauthorized: () => {
    // Only force logout once (avoid reload loops during initial session check)
    if (!didForceLogout) {
      didForceLogout = true;
    }
  },
});

export const api = {
  auth: authEndpoints(client),
  approvals: approvalEndpoints(client),
  hospitals: hospitalEndpoints(client),
  push: pushEndpoints(client),
  settings: settingsEndpoints(client),
  intake: intakeEndpoints(client),
  raw: client.raw,
};
